// extracted by mini-css-extract-plugin
export default {"buyPop":"claimBonusPop_buyPop__YCA11","price":"claimBonusPop_price__0Zu+d"};